module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Own value":"Eigener Wert","Use product value":"Produktwert verwenden","Inherited from product":"Vom Produkt übernommen"}}')
  delete Component.options._Ctor
}
